import React, { useState, useEffect, useCallback } from 'react';
import Slider from 'react-slick';
import axios from 'axios';
import EweProductCard from './EweProductCard';
import '../styles/MainCategoriesCarousel.css';

const MainCategoriesCarousel = ({ isLoggedIn, refreshCart, handleCategoryClick }) => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  // Carousel settings
  const carouselSettings = React.useMemo(() => ({
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 5,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 3, slidesToScroll: 3 }
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 2, slidesToScroll: 2 }
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1, slidesToScroll: 1 }
      }
    ]
  }), []);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${API_BASE_URL}/ewe/products/maincategory/random?perCategory=20`
      );

      // Transform response data to match our structure
      const categoriesData = Object.entries(response.data).map(([categoryId, categoryData]) => ({
        id: parseInt(categoryId),
        name: categoryData.categoryName,
        products: categoryData.products
      }));

      setCategories(categoriesData);
      setLoading(false);
    } catch (err) {
      console.error("Error loading carousel data:", err);
      setError(err.message);
      setLoading(false);
    }
  }, [API_BASE_URL]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleSeeAllClick = useCallback((category) => {
    handleCategoryClick?.({
      id: category.id,
      name: category.name,
      type: "main"
    });
  }, [handleCategoryClick]);

  if (loading) return <div className="loading-spinner">Loading...</div>;
  if (error) return <div className="error-message">Error loading carousel</div>;

  return (
    <div className="main-categories-carousel">
      {categories.map(category => (
        <div key={category.id} className="category-carousel-section">
          <h2 className="category-title">{category.name}</h2>

          {category.products?.length > 0 ? (
            <>
              <Slider {...carouselSettings}>
                {category.products.map(product => (
                  <div key={product.productKey} className="carousel-item">
                    <EweProductCard
                      product={product}
                      isLoggedIn={isLoggedIn}
                      refreshCart={refreshCart}
                    />
                  </div>
                ))}
              </Slider>
              <button
                onClick={() => handleSeeAllClick(category)}
                className="see-all-button"
              >
                Vidi sve iz {category.name}
              </button>
            </>
          ) : (
            <div className="no-products">No products available</div>
          )}
        </div>
      ))}
    </div>
  );
};

export default React.memo(MainCategoriesCarousel);